(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-data/assets/javascripts/actions/receive-message.js') >= 0) return;  svs.modules.push('/components/chat/chat-data/assets/javascripts/actions/receive-message.js'); 'use strict';

const _excluded = ["chatRoomId", "user", "created", "timestamp", "isAuthorOfMessage", "status", "clientToken"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const CHAT_RECEIVE_MESSAGE = 'CHAT/CHAT_RECEIVE_MESSAGE';
const {
  log,
  constants,
  helpers
} = svs.components.chat.chatData;
const socketReceiveMessage = (roomId, response) => (dispatch, getState) => {
  log.debug("Socket receive message (error: ".concat(!!response.error, ")"));
  if (!response.error && response.result) {
    log.debug("Socket receive messageId ".concat(response.result.message.id));
    const _response$result$mess = response.result.message,
      {
        chatRoomId,
        user,
        created,
        timestamp,
        isAuthorOfMessage,
        status: serverStatus,
        clientToken
      } = _response$result$mess,
      messageData = _objectWithoutProperties(_response$result$mess, _excluded);
    const chatState = getState().Chat,
      customerId = chatState.customerId,
      messageIsInState = (chatState.messages[roomId] || []).find(msg => msg.id === messageData.id);

    if (messageIsInState && serverStatus === constants.SERVER_MESSAGE_STATUS_ORIGINAL) {
      log.debug("New message not dispatched already in store, messageId: ".concat(messageData.id));
      return;
    }

    if (!messageIsInState && serverStatus !== constants.SERVER_MESSAGE_STATUS_ORIGINAL) {
      return;
    }
    dispatch({
      type: CHAT_RECEIVE_MESSAGE,
      roomId,
      increaseUnreadCount: serverStatus === constants.SERVER_MESSAGE_STATUS_ORIGINAL && !chatState.isOpen ? 1 : 0,
      clientToken: customerId === user.id ? clientToken : null,
      messageData: helpers.formatMessage(_objectSpread(_objectSpread({}, response.result.message), {}, {
        isAuthorOfMessage: customerId === user.id,
        isRetailer: user.isEditor
      }))
    });
  }
};
setGlobal('svs.components.chat.chatData.actions', {
  socketReceiveMessage,
  CHAT_RECEIVE_MESSAGE
});
 })(window);